var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error-page"},[_c('div',{staticClass:"error-cont"},[_c('strong',[_vm._v("이용에 불편을 드려 죄송합니다.")]),_c('p',[_vm._v("요청하신 페이지를 찾을 수 없습니다.")]),_c('a',{staticClass:"btn",attrs:{"href":"/usr/main"}},[_vm._v("사이트 메인으로 이동")])])])
}]

export { render, staticRenderFns }